import module from 'empresa/module.js'
import template from './template.html'


export class EmpresaConfiguracionFacturacionDireccionesItemComponent {
  data
  editando = false
  empresaId

}

module.component('empresaConfiguracionFacturacionDireccionesItem', {
  controller: EmpresaConfiguracionFacturacionDireccionesItemComponent,
  template,
  bindings: {
    empresaId: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/configuracion/facturacion/direcciones/item/component.js